import React, { useState, useLayoutEffect,useRef,useEffect }  from 'react'

const Navbar = () => {
// Change Theme
debugger
const [isDark, SetIsDark] = useState(false)
const themeButton = useRef('');
const menulist = useRef('');
const selectedTheme = localStorage.getItem('selected-theme');
const selectedIcon = localStorage.getItem('selected-icon');
useEffect(() => {

 if (selectedTheme==='dark') {
    SetIsDark(true);
}else if ( selectedTheme==='light'){
     SetIsDark(false);
}
}, [isDark])

const darkTheme = 'dark-theme'
const iconTheme = 'bx-sun'
// Previously selected topic (if user selected)

const getCurrentTheme = () => document.body.classList.contains(darkTheme) ? 'dark' : 'light'
const getCurrentIcon = () => themeButton.current.classList.contains(iconTheme) ? 'bx-moon' : 'bx-sun'
// Activate / deactivate the theme manually with the button

// We validate if the user previously chose a topic
if (selectedTheme) {
  // If the validation is fulfilled, we ask what the issue was to know if we activated or deactivated the dark
  document.body.classList[selectedTheme === 'dark' ? 'add' : 'remove'](darkTheme)
  //themeButton.classList[selectedIcon === 'dark' ? 'add' : 'remove'](iconTheme)
}
const handleChangeTheme = (event) => {
    debugger
    // Add or remove the dark / icon theme
    document.body.classList.toggle(darkTheme)

    if(selectedIcon=='bx-moon'){
      themeButton.current.classList.add('bx-moon')
      themeButton.current.classList.remove('bx-sun')
    }else  if(selectedIcon=='bx-sun'){
      themeButton.current.classList.add('bx-sun')
      themeButton.current.classList.remove('bx-moon')
    }else{
      themeButton.current.classList.toggle(iconTheme)
    }
  //  
    // We save the theme and the current icon that the user chose
    localStorage.setItem('selected-theme', getCurrentTheme())
    localStorage.setItem('selected-icon', getCurrentIcon())
  };

    const [isActive, setIsActive] = useState(false);
  const handleClick = (event) => {
    // ️ toggle isActive state on click
    setIsActive((current) => !current);
  };
  const navLink = document.querySelectorAll(".nav__link");

  function linkAction() {
    debugger;
    const navMenu = document.getElementById("nav-menu");
    // When we click on each nav__link, we remove the show-menu class
    navMenu.classList.remove("show-menu");
  }
  navLink.forEach((n) => n.addEventListener("click", linkAction));



 
  const toggleQulify = (event) => {
    debugger;
    const target = event.currentTarget;
    console.log(menulist.current.childNodes[0].childNodes[0].classList);
    menulist.current.childNodes.forEach((menu,index) => {
        menu.childNodes[0].classList.remove("active-link");
      console.log(menu.childNodes,index);
    });
    target.classList.add("active-link");
  };
  return (
    <>
     <header className="l-header" id="header">
            <nav className="nav bd-container">
                <a href="#" className="nav__logo">Tasty</a>

                <div className={`nav__menu ${isActive ? "show-menu" : ""}`} id="nav-menu">
                    <ul className="nav__list" ref={menulist}>
                        <li className="nav__item"><a href="#home" className="nav__link active-link" onClick={toggleQulify}>Home</a></li>
                        <li className="nav__item"><a href="#about" className="nav__link" onClick={toggleQulify}>About</a></li>
                        <li className="nav__item"><a href="#services" className="nav__link" onClick={toggleQulify}>Services</a></li>
                        <li className="nav__item"><a href="#menu" className="nav__link" onClick={toggleQulify}>Menu</a></li>
                        <li className="nav__item"><a href="#contact" className="nav__link" onClick={toggleQulify}>Contact us</a></li>

                       
                    </ul>
                </div>

                <div className='change-theme'><i className={`bx  ${isDark ? " bx-sun" : " bx-moon"}`} id="theme-button" ref={themeButton} onClick={handleChangeTheme}></i>
                <div className="nav__toggle" id="nav-toggle" onClick={handleClick}>
                    <i className='bx bx-menu'></i>
                </div>
                </div>
               
            </nav>
        </header>
    </>
  )
}

export default Navbar